import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';

/**
 * Component that renders an input field for searching purposes. It has a
 * search button that allows the user to trigger action after clicking it or
 * hitting an enter key. Also has a clear button to clear the value of input
 * field after the user typed something.
 */
var SearchFieldComponent = /** @class */ (function (_super) {
    __extends(SearchFieldComponent, _super);
    function SearchFieldComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Emitted when clear button has been clicked
     */
    SearchFieldComponent.prototype.onClear = function () {
        this.afterClear();
        return;
    };
    SearchFieldComponent.prototype.afterClear = function () {
        return '';
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], SearchFieldComponent.prototype, "value", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], SearchFieldComponent.prototype, "placeholder", void 0);
    __decorate([
        Emit('clear'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SearchFieldComponent.prototype, "onClear", null);
    __decorate([
        Emit('input'),
        Emit('change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SearchFieldComponent.prototype, "afterClear", null);
    SearchFieldComponent = __decorate([
        Component({
            name: 'ui-search-field',
            inheritAttrs: false,
        })
    ], SearchFieldComponent);
    return SearchFieldComponent;
}(Mixins(MagicConfigMixin)));

export default SearchFieldComponent;
